import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_2 = { class: "mb-0 text-paragraph" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "mt-15 mt-md-0" }
const _hoisted_7 = { class: "pagination mb-0" }
const _hoisted_8 = {
  key: 0,
  class: "page-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "page-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _cache[2] || (_cache[2] = _createTextVNode(" Affichage de ", -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.currentFrom), 1),
      _cache[3] || (_cache[3] = _createTextVNode(" – ", -1)),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentTo), 1),
      _cache[4] || (_cache[4] = _createTextVNode(" sur ", -1)),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pagination.total), 1),
      _cache[5] || (_cache[5] = _createTextVNode(" résultats ", -1))
    ]),
    _createElementVNode("nav", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        (_ctx.pagination.current_page > 1)
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                "aria-label": "Previous",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.current_page - 1)), ["prevent"]))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
              ]))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagesNumber, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            key: page,
            class: "page-item"
          }, [
            _createElementVNode("a", {
              class: _normalizeClass(["page-link", { active: page === _ctx.pagination.current_page }]),
              href: "#",
              onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
            }, _toDisplayString(page), 11, _hoisted_9)
          ]))
        }), 128)),
        (_ctx.pagination.current_page < _ctx.pagination.last_page)
          ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                "aria-label": "Next",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.pagination.current_page + 1)), ["prevent"]))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
              ]))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}